import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'EditorialHeadingParagraph',
})(({ spacing, brandColors, breakpoints, typography }, props) => ({
  container: {
    padding: `${spacing(0)} 0`,
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
  },
  spacer: {
    paddingTop: spacing(5),
  },
  heading: {
    marginBottom: spacing(0),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  textColor: {
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  embeddedContent: {
    margin: `${spacing(2)} 0`,
    [breakpoints.up('sm')]: {
      padding: `0 ${typography.pxToRem(20)}}`,
    },
    [breakpoints.up('md')]: {
      padding: `0 ${typography.pxToRem(44)}}`,
    },
  },
}));

export default useStyles;
